// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__RJCsD","selects":"Documents_selects__indl2"};